document.addEventListener('DOMContentLoaded', function () {
    if (null === document.querySelector('.page-contact-brand')) {
        return;
    }

    let contactButton = document.querySelector('#contact-us-button');
    if (null === contactButton) {
        return;
    }

    let formModal = new Modal({
        'id': 'maier-container-form-modal',
        'create': true,
        'excludedAutoCloseSelectors': ['#contact-us-button']
    });

    let form = document.querySelector('.maier-container-form');
    document.querySelector('.maier-container-form-modal .content').appendChild(form);

    contactButton.addEventListener('click', function (e) {
        formModal.show();

        e.preventDefault();
    });
})
